import * as React from "react"

import RadioMultiButton from "./RadioButton"
import { useCommonFilters } from '../../hooks'


export default function RadioAlert({ ...props }) {

    const { alerts, setAlerts, setAlertType } = useCommonFilters()

    const configRadio = {
        value: alerts, onChange: setAlerts, changeAlertType: setAlertType,
        items: [
            { label: 'Competition', value: 'competition' },
            { label: 'Parity', value: 'parity', disabled: true },
            { label: 'Packages', value: 'packages', disabled: true }
        ],
        ...props
    }

    return <RadioMultiButton {...configRadio} />
}